import { string } from 'prop-types';
import React from 'react';
import './styles.scss';

const FormTitle = ({ customClass = '', text }) => (
  <h4 className={`${customClass.length ? customClass : 'form-title'} form-title-size `}>{ text }</h4>
);

FormTitle.propTypes = {
  text: string.isRequired,
  customClass: string
}

export default FormTitle;
